import styles from './BillsList.module.scss'
import { RiBillLine } from 'react-icons/ri';
import { RiArrowGoBackFill } from 'react-icons/ri';
import { AiOutlineLoading3Quarters, AiOutlineArrowUp } from 'react-icons/ai';
import { BiSolidDownArrow, BiSolidUpArrow } from 'react-icons/bi';
import { MdOutlineContentPaste, MdOutlineContentPasteOff } from 'react-icons/md';
import { GiConfirmed } from 'react-icons/gi';
import { HiOutlineDocumentText } from 'react-icons/hi';
import { useNavigate, useParams } from 'react-router-dom';
import React, { useEffect, useState, useRef } from 'react';
import { useForm } from 'react-hook-form';
import ReactModal from 'react-modal';
import api from '../../services/api'
import { toast } from 'react-toastify'
import { getValue } from '@testing-library/user-event/dist/utils';

function BillsList() {
  const [bills, setBills] = useState({});
  // const [billsIndices, setBills] = useState([]);
  const [billsOpen, setBillsOpen] = useState([]);
  const [loading, setLoading] = useState(true);
  const [boletosOpen, setBoletosOpen] = useState([]);
  const [showModalEstrangeiro, setShowModalEstrangeiro] = useState(false);
  const [moedaEstrangeiraInfo, setMoedaEstrangeiraInfo] = useState({})
  const [, setValorEstrangeiro] = useState('');
  const [tipoTaxaMP, setTipoTaxaMP] = useState('');
  const [taxaMP, setTaxaMP] = useState(0);
  const [valorTaxaMP, setValorTaxaMP] = useState(0);
  const [valorParcela, setValorParcela] = useState(0);
  const [valorJurosCliente, setValorJurosCliente] = useState(0)
  const [coeficienteCliente, setCoeficienteCliente] = useState(1)
  const [showFieldsCard, setShowFieldsCard] = useState(false);
  const [activeModalTab, setActiveModalTab] = useState('real');
  const [hoveredTab, setHoveredTab] = useState(null);
  const [highlightedSaleId, setHighlightedSaleId] = useState(null);
  const [currentModalBillId, setCurrentModalBillId] = useState(null);
  const [loadingUpload, setLoadingUpload] = useState(false);
  const uploadComprovanteRef = useRef([]);

  // Estados aba Pagamento em Moeda Estrangeira
  const [fieldValidationsEst, setFieldValidationsEst] = useState({
    valor: true,
    datavencimento: true,
    banco: true
  });

  const navigate = useNavigate();

  const [fieldValidations, setFieldValidations] = useState({
    valor: true,
    formadepagamento: true,
    datavencimento: true,
    parcelas: true
  });

//   const updateFieldValidation = (fieldName, isValid, value) => {
//     setFieldValidations((prevValidations) => ({
//       ...prevValidations,
//       [fieldName]: isValid,
//     }));

//     if (fieldName === "valor") {
//       const cambio = parseFloat(moedaEstrangeiraInfo?.moedaestrangeiracambio || 0);
//       const valorNum = parseFloat(value.replace(',', '.') || 0);
//       const valorIof = parseFloat(valorNum*(moedaEstrangeiraInfo.taxaiof/100))

//       if (cambio > 0 && valorNum > 0) {
//         setValorEstrangeiro((valorNum / cambio).toFixed(2));
//         setMoedaEstrangeiraInfo(prev => ({
//           ...prev,         
//           valoriof: valorIof.toFixed(2)
//         }));
//       } else {
//         setValorEstrangeiro('');
//       }
//     }

// if (fieldName === "formadepagamento" && false) {
//   if (value === "pix") {
//     setMoedaEstrangeiraInfo((prev) => ({
//       ...prev,
//       valoriof: 0,
//     }));
//   } else {
//     setMoedaEstrangeiraInfo((prev) => {
//       const rawValor = watch("valor");
//       console.log("rawValor:", rawValor);
//       const valorNum = parseFloat(
//         String(rawValor || "0").replace(/[^\d,]/g, "").replace(",", ".")
//       );
//       const taxaIof = parseFloat(prev?.taxaiof || 0);
//       console.log("valorNum:", valorNum, "taxaIof:", taxaIof);

//       const valorIof = isNaN(valorNum) || isNaN(taxaIof)
//         ? 0
//         : valorNum * (taxaIof / 100);

//       return {
//         ...prev,
//         valoriof: valorIof.toFixed(2),
//       };
//     });
//   }
// }
//   };

const updateFieldValidationEst = (fieldName, isValid) => {
  setFieldValidationsEst((prev) => ({ ...prev, [fieldName]: isValid }));
};

const updateFieldValidation = (fieldName, isValid, value) => {
  setFieldValidations((prev) => ({ ...prev, [fieldName]: isValid }));

  if (fieldName === "formadepagamento") {
    getCoeficiente(value);
    if(value == 'cartao') {
      setShowFieldsCard(true)

    }else{
      setShowFieldsCard(false)
    }
  }

  if (fieldName === "valor" || fieldName === "parcelas") {


    
    if(fieldName == "valor"){ 
      var valor = value;
    }else{
      var valor = getValues('valor')
    }

    if(fieldName == "parcelas"){ 
      var parcelas = value;
    }else{
      var parcelas = getValues('parcelas')
    }

    var cambio = Number(moedaEstrangeiraInfo?.moedaestrangeiracambio || 0);
    var valorNum = parseMoneyBR(valor); // <-- aqui
    var valorNumClean = parseMoneyBR(valor); // <-- aqui
    var taxaIof = Number(moedaEstrangeiraInfo?.taxaiof || 0);
    var valorIof = parseMoneyBR(valorNum) * (taxaIof / 100);


      console.log(valorNumClean);

      const newValorTaxaMP = tipoTaxaMP == 'P'
        ? parseFloat(valorNumClean * (taxaMP / 100))
        : taxaMP;
      setValorTaxaMP(newValorTaxaMP);

			var valorTotalJuros = parseFloat(valorNumClean)+parseFloat(valorNumClean*coeficienteCliente);
			var valorParcelaSemTaxas = parseFloat(valorNumClean/parcelas);

      // Valor parcela = (valor / parcelas) + (iof / parcelas) + (mp / parcelas)
      // Para NÃO incluir o MP na parcela, comente a parcela do MP abaixo e use a linha alternativa:
      // setValorParcela(parseFloat(valorParcelaSemTaxas) + parseFloat(valorIof / parcelas));
      setValorParcela(parseFloat(valorParcelaSemTaxas) + parseFloat(valorIof / parcelas) + parseFloat(newValorTaxaMP) / parseInt(parcelas));
      setValorJurosCliente(valorTotalJuros)

    if (cambio > 0 && valorNum > 0) {
      setValorEstrangeiro((valorNum / cambio).toFixed(2));
      setMoedaEstrangeiraInfo((prev) => ({
        ...prev,
        valoriof: valorIof.toFixed(2),
      }));
    } else {
      setValorEstrangeiro("");
      setMoedaEstrangeiraInfo((prev) => ({ ...prev, valoriof: "0.00" }));
    }
  }
};


  function parseMoneyBR(input) {
  if (!input) return 0;
  const cleaned = String(input)
    .replace(/\s/g, '')
    .replace(/[R$]/g, '')
    .replace(/\./g, '')
    .replace(',', '.')
    .replace(/[^0-9.]/g, '');

  const n = Number(cleaned);
  return Number.isFinite(n) ? n : 0;
}

function formatMoneyBR(value, currency = "BRL") {
  const n = Number(value);
  if (!Number.isFinite(n)) return "";
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency,
  }).format(n);
}

function formatNumberBR(value, decimals = 2) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "";
  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(n);
}

    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate());
    const formattedTomorrow = tomorrow.toISOString().split("T")[0]; // yyyy-mm-dd

  const {
    register,
    handleSubmit,
    reset,
    trigger,
    setValue,
    watch,
    getValues,
    formState: { errors },
      } = useForm({
      defaultValues: {
         datavencimento: formattedTomorrow,
        },
    });

  const {
    register: registerEst,
    handleSubmit: handleSubmitEst,
    reset: resetEst,
    trigger: triggerEst,
    setValue: setValueEst,
    getValues: getValuesEst,
    formState: { errors: errorsEst },
  } = useForm({
    defaultValues: {
      datavencimentoest: formattedTomorrow,
    },
  });

    function maskMoneyBR(raw) {
      // deixa só dígitos
      const digits = String(raw).replace(/\D/g, "");
      if (!digits) return "";

      // interpreta como centavos
      const asNumber = Number(digits) / 100;
      return formatNumberBR(asNumber, 2); // "1.234,56"
    }

  const [update, setUpdate] = useState(1)

  useEffect(() => {
    if (!highlightedSaleId) return;
    const scrollTimer = setTimeout(() => {
      const el = document.getElementById(`sale-${highlightedSaleId}`);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 600);
    const clearTimer = setTimeout(() => setHighlightedSaleId(null), 5000);
    return () => { clearTimeout(scrollTimer); clearTimeout(clearTimer); };
  }, [highlightedSaleId]);

  useEffect(() => {
    api.post('/finantial/')
    .then((res) => {
      let dataArray = [];
      let apiResponse =res.data.retorno;
      for (const key in apiResponse) {
        if (Object.hasOwnProperty.call(apiResponse, key)) {
          const dataObject = {
            id: key, // Set the 'id' property to the key (e.g., "522004")
            ...apiResponse[key], // Include the nested data
          };
          dataArray.push(dataObject);
        }
      }
      
      setBills(dataArray);
      console.log(dataArray);

      dataArray.map(x => {
        console.log(x['cartao'])
      });

      
      setLoading(false);
    }).catch((err) => {
      console.log(err)
      setLoading(false);
    })
  }, [update])

  function handleBoletos(id) {
    let newArr = [...boletosOpen];
    if(boletosOpen.includes(id)) {
      newArr.splice(boletosOpen.indexOf(id), 1);
      setBoletosOpen(newArr);

      return;
    }

    newArr.push(id);
    setBoletosOpen(newArr);
  }

 function handleDropDown(id){
  console.log(billsOpen, id);
    let newArr = [...billsOpen];
    if(billsOpen.includes(id)) {
      newArr.splice(billsOpen.indexOf(id), 1);
      setBillsOpen(newArr);

      return;
    }

    newArr.push(id);
    setBillsOpen(newArr);
 }

   async function sendData(data){

    if(data.valor < 10) {
      toast.error('Valor do pagamento invállido, insira um valor maior!');
      return;
    }

    console.log(fieldValidations);
    setLoading(true);

    let response = await api.post('/finantialsaldoestrangeiro', {
      parcelas: data.parcelas,
      valor: parseMoneyBR(data.valor).toFixed(2),
      formadepagamento: data.formadepagamento,
      datavencimento: data.datavencimento,
      moeda: moedaEstrangeiraInfo.moedaestrangeiramoeda,
      totalestrangeiro: moedaEstrangeiraInfo.moedaestrangeiratotal,
      idreservaquarto: moedaEstrangeiraInfo.idvenda,
      taxaiof: moedaEstrangeiraInfo.taxaiof,
      valoriof: moedaEstrangeiraInfo.valoriof,
      cambio: moedaEstrangeiraInfo.moedaestrangeiracambio,
      restricao: 0, 
      coeficienteefetivo: 1, 
      coeficientecliente: coeficienteCliente, 
      coeficientefranquia: 1, 
      juroscliente: 0, 
      jurosefetivo: 0, 
      jurosfranquia: 0, 
      desagiofranquia: 0, 
      desagioefetivo: 0, 
      valorjuroscliente: 0, 
      valorjurosfranquia: 0, 
      valorjurosefetivo: 0, 
      valordesagiofranquia: 0, 
      valordesagioefetivo: 0,
      taxamp: taxaMP,
      valortaxamp: valorTaxaMP,
      valordescontoparcela: 0
    })

    if(!response.data.sucesso){
      toast.error(response.data.mensagem);
      setLoading(false);
      return;
    }

    setShowModalEstrangeiro(false);
    setBillsOpen(prev => prev.includes(currentModalBillId) ? prev : [...prev, currentModalBillId]);
    setHighlightedSaleId(currentModalBillId);
    setUpdate(update+1);

    reset({
      valor: '',
      formadepagamento: '',
    })
    setLoading(false);
    toast.success('Pagamento criado com sucesso, confira os detalhes na listagem');
  }

  async function getCoeficiente(value) {
    const parcelas = getValues('parcelas');
    const formadepagamento = value;

    const url =
      formadepagamento === 'pix'
        ? '98/1/M'
        : `113/${String(parcelas)}/M`;

    const response = await api.get('/coeficiente_by_pagamento/' + url);

    if (!response.data.sucesso) {
      toast.error(response.data.mensagem);
      setLoading(false);
      return;
    }


    setTaxaMP(response.data.retorno.taxamp ?? 0)
    setTipoTaxaMP(response.data.retorno.tipotaxamp ?? '')


    setLoading(false);
    toast.success(response.data.mensagem);
  }

  async function sendDataEstrangeiro(data) {
    if (!data.valorest || parseMoneyBR(data.valorest) <= 0) {
      toast.error('Valor do pagamento inválido, insira um valor maior!');
      return;
    }

    setLoading(true);

    let response = await api.post('/finantialsaldoestrangeiro', {
      parcelas: 1,
      valor: parseMoneyBR(data.valorest).toFixed(2),
      formadepagamento: 'depositoestrangeiro',
      datavencimento: data.datavencimentoest,
      banco: data.banco,
      moeda: moedaEstrangeiraInfo.moedaestrangeiramoeda,
      totalestrangeiro: moedaEstrangeiraInfo.moedaestrangeiratotal,
      idreservaquarto: moedaEstrangeiraInfo.idvenda,
      taxaiof: moedaEstrangeiraInfo.taxaiof,
      valoriof: moedaEstrangeiraInfo.valoriof,
      cambio: moedaEstrangeiraInfo.moedaestrangeiracambio,
      restricao: 0,
      coeficienteefetivo: 1,
      coeficientecliente: 1,
      coeficientefranquia: 1,
      juroscliente: 0,
      jurosefetivo: 0,
      jurosfranquia: 0,
      desagiofranquia: 0,
      desagioefetivo: 0,
      valorjuroscliente: 0,
      valorjurosfranquia: 0,
      valorjurosefetivo: 0,
      valordesagiofranquia: 0,
      valordesagioefetivo: 0,
      taxamp: 0,
      valortaxamp: 0,
      valordescontoparcela: 0
    });

    if (!response.data.sucesso) {
      toast.error(response.data.mensagem);
      setLoading(false);
      return;
    }

    setShowModalEstrangeiro(false);
    setBillsOpen(prev => prev.includes(currentModalBillId) ? prev : [...prev, currentModalBillId]);
    setHighlightedSaleId(currentModalBillId);
    setUpdate(update + 1);

    resetEst({ valorest: '' });
    setLoading(false);
    toast.success('Pagamento criado com sucesso, confira os detalhes na listagem');
  }


  function openModal(data, billId) {
    // Aba Real
    setValue("valor", 0);
    setValue("parcelas", 1);
    setValue("formadepagamento", "pix");
    setValue("valorestrangeiro", '');
    setValorEstrangeiro('');
    setValorParcela(0);
    setValorTaxaMP(0);
    setShowFieldsCard(false);
    getCoeficiente('pix');

    // Aba Estrangeiro
    setValueEst("valorest", '');
    setValueEst("datavencimentoest", formattedTomorrow);

    setActiveModalTab('real');
    setShowModalEstrangeiro(true);
    setMoedaEstrangeiraInfo(data);
    setCurrentModalBillId(billId);
  }


  function maskMoneyBR(raw) {
  // deixa só dígitos
  const digits = String(raw).replace(/\D/g, "");
  if (!digits) return "";

  // interpreta como centavos
  const asNumber = Number(digits) / 100;
  return formatNumberBR(asNumber, 2); // "1.234,56"
}

  function handleUploadComprovante(id) {
    if (uploadComprovanteRef.current[id]) {
      uploadComprovanteRef.current[id].click();
    }
  }

  function handleChangeUploadComprovante(e) {
    const input = e.target;
    const selectedFile = input.files[0];
    const id = e.target.getAttribute('data-id');
    const idlancamento = e.target.getAttribute('data-idlancamento');
    const idvenda = e.target.getAttribute('data-idvenda');
    const idformapagamento = e.target.getAttribute('data-idformapagamento');

    if (!selectedFile) {
      toast.error('Nenhum arquivo selecionado.');
      return;
    }

    if (selectedFile.size > 5 * 1024 * 1024) {
      toast.error('O arquivo excede o tamanho permitido de 5mb.');
      return;
    }

    const allowedExtensions = ['.jpg', '.jpeg', '.png', '.pdf'];
    const fileExtension = selectedFile.name.substr(selectedFile.name.lastIndexOf('.')).toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      toast.error('Formato inválido, somente imagem ou pdf são permitidos.');
      return;
    }

    const data = new FormData();
    // data.append(`arquivo_${id}`, selectedFile);
    data.append(`file`, selectedFile);
    data.append('id', id);
    data.append('idlancamento', idlancamento);
    data.append('idreservaquarto', idvenda);
    data.append('idformapagamento', idformapagamento);

    setLoadingUpload(true);

    api.post('/uploadcomprovantepagamentoestrangeiro/', data)
      .then((res) => {
        if (res.data.sucesso) {
          toast.success(res.data.mensagem);
          setUpdate(u => u + 1);
        } else {
          toast.error(res.data.mensagem);
        }
      })
      .catch(() => {
        toast.error('Erro ao enviar o comprovante.');
      })
      .finally(() => {
        input.value = '';
        setLoadingUpload(false);
      });
  }


  return (
    <div className={styles.container}>
      <div className={styles.headerList}>
        <h2><RiBillLine/> Meus pagamentos</h2>
        <button onClick={() => navigate(-1)}><RiArrowGoBackFill/></button>
      </div>
      { loading ? <div className={styles.loading}><AiOutlineLoading3Quarters/></div> :
      <>

          <ReactModal
            isOpen={showModalEstrangeiro}
            onRequestClose={() => setShowModalEstrangeiro(false)}
            contentLabel="Informações Estrangeiro"
            className="Modal"
            overlayClassName="Overlay"
          >
            <h2>Preencha o valor a pagar</h2>

            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginBottom: '16px' }}>
              <button
                type="button"
                style={{
                  flex: 1,
                  padding: '10px 8px',
                  backgroundColor: activeModalTab === 'real' ? '#FB6700' : hoveredTab === 'real' ? '#E2E5E9' : '#F0F2F5',
                  color: activeModalTab === 'real' ? '#FFF' : '#FB6700',
                  border: 'none',
                  borderRadius: '6px 6px 0 0',
                  cursor: 'pointer',
                  fontSize: '13px',
                  fontWeight: activeModalTab === 'real' ? '700' : '500',
                  transition: 'background-color 0.15s',
                }}
                onClick={() => setActiveModalTab('real')}
                onMouseEnter={() => setHoveredTab('real')}
                onMouseLeave={() => setHoveredTab(null)}
              >
                Pagamento em Real
              </button>
              <button
                type="button"
                style={{
                  flex: 1,
                  padding: '10px 8px',
                  backgroundColor: activeModalTab === 'estrangeiro' ? '#FB6700' : hoveredTab === 'estrangeiro' ? '#E2E5E9' : '#F0F2F5',
                  color: activeModalTab === 'estrangeiro' ? '#FFF' : '#FB6700',
                  border: 'none',
                  borderRadius: '6px 6px 0 0',
                  cursor: 'pointer',
                  fontSize: '13px',
                  fontWeight: activeModalTab === 'estrangeiro' ? '700' : '500',
                  transition: 'background-color 0.15s',
                }}
                onClick={() => setActiveModalTab('estrangeiro')}
                onMouseEnter={() => setHoveredTab('estrangeiro')}
                onMouseLeave={() => setHoveredTab(null)}
              >
                Pagamento em {moedaEstrangeiraInfo.moedaestrangeirasigla || 'Moeda Estrangeira'}
              </button>
            </div>

            {/* Aba: Pagamento em Real */}
            {activeModalTab === 'real' && (
              <form className={styles.formEstrangeiro} onSubmit={handleSubmit(sendData)}>
                <div className={styles.inputbox}>
                  <span>Forma de pagamento</span>
                  <select name="formadepagamento"
                    {...register("formadepagamento", { required: "O valor é obrigatório" })}
                    onChange={(e) => {
                      const value = e.target.value;
                      trigger("formadepagamento").then((isValid) => updateFieldValidation('formadepagamento', isValid, value));
                    }}
                  >
                    <option selected value="pix">Pix</option>
                    <option value="cartao">Cartão de Crédito</option>
                  </select>
                </div>

                <div className={`${styles.inputbox} ${fieldValidations.valor ? '' : styles.invalid}`}>
                  <span>Valor *</span>
                  <span className={styles.currencyPrefix}>R$</span>
                  <input
                    type="text"
                    placeholder="0,00"
                    style={{ paddingLeft: '30px' }}
                    {...register("valor", { required: "O valor é obrigatório" })}
                    onChange={(e) => {
                      const masked = maskMoneyBR(e.target.value);
                      setValue("valor", masked, { shouldDirty: true, shouldValidate: true });
                      trigger("valor").then((isValid) => updateFieldValidation("valor", isValid, masked));
                    }}
                  />
                </div>

                {showFieldsCard &&
                  <div className={`${styles.inputbox} ${fieldValidations.parcelas ? '' : styles.invalid}`}>
                    <span>Parcelas *</span>
                    <select name="parcelas"
                      {...register("parcelas", { required: "Número de parcelas é obrigatório" })}
                      onChange={(e) => {
                        const value = e.target.value;
                        setValue('parcelas', value);
                        trigger("parcelas").then((isValid) => updateFieldValidation('parcelas', isValid, value));
                      }}
                    >
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                    </select>
                  </div>
                }

                <div className={`${styles.inputbox} ${fieldValidations.datavencimento ? '' : styles.invalid}`}>
                  <span>Data Vencimento *</span>
                  <input type="date" readOnly name="datavencimento" value={formattedTomorrow}
                    {...register("datavencimento", { required: "O valor é obrigatório",
                      minLength: { value: 2, message: "Mínimo 2 caracteres" }
                    })}
                    onKeyUp={() => {
                      trigger("datavencimento").then((isValid) => updateFieldValidation('datavencimento', isValid));
                    }}
                  />
                </div>

                <div className={styles.readonlyBox}>
                  <span className={styles.readonlyBoxTitle}>Detalhes do seu pagamento</span>
                  <div className={styles.inputbox}>
                    <span>IOF</span>
                    <span className={styles.currencyPrefix}>R$</span>
                    <input type="text" disabled value={Number(moedaEstrangeiraInfo?.valoriof || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} style={{ paddingLeft: '30px' }}/>
                  </div>

                  {showFieldsCard && <>
                    <div className={styles.inputbox}>
                      <span>Taxa MP</span>
                      <span className={styles.currencyPrefix}>R$</span>
                      <input type="text" disabled value={Number(valorTaxaMP).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} placeholder="0,00" style={{ paddingLeft: '30px' }}/>
                    </div>
                    <div className={styles.inputbox}>
                      <span>Valor parcela (Em {watch('parcelas') || 1}x)</span>
                      <span className={styles.currencyPrefix}>R$</span>
                      <input type="text" disabled value={Number(valorParcela).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} placeholder="0,00" style={{ paddingLeft: '30px' }}/>
                    </div>
                  </>}

                  <div className={styles.inputbox}>
                    <span>Valor total a pagar</span>
                    <span className={styles.currencyPrefix}>R$</span>
                    <input type="text" disabled value={(parseMoneyBR(getValues('valor')) + parseFloat(moedaEstrangeiraInfo?.valoriof || 0) + (showFieldsCard ? valorTaxaMP : 0)).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} placeholder="0,00" style={{ paddingLeft: '30px' }}/>
                  </div>
                </div>

                <div className={styles.formButtons}>
                  <button type="submit">Enviar</button>
                  <button type="button" onClick={() => setShowModalEstrangeiro(false)}>Fechar</button>
                </div>
              </form>
            )}

            {/* Aba: Pagamento em Moeda Estrangeira */}
            {activeModalTab === 'estrangeiro' && (
              <form className={styles.formEstrangeiro} onSubmit={handleSubmitEst(sendDataEstrangeiro)}>
                <div className={`${styles.inputbox} ${fieldValidationsEst.datavencimento ? '' : styles.invalid}`}>
                  <span>Data Vencimento *</span>
                  <input type="date" readOnly name="datavencimentoest" value={formattedTomorrow}
                    {...registerEst("datavencimentoest", { required: "O valor é obrigatório" })}
                  />
                </div>
                <div className={`${styles.inputbox} ${fieldValidationsEst.valor ? '' : styles.invalid}`}>
                  <span>Valor em {moedaEstrangeiraInfo.moedaestrangeirasigla || 'moeda estrangeira'} *</span>
                  <span className={styles.currencyPrefix}>{moedaEstrangeiraInfo.moedaestrangeirasigla || ''}</span>
                  <input
                    type="text"
                    placeholder="0,00"
                    style={{ paddingLeft: '46px' }}
                    {...registerEst("valorest", { required: "O valor é obrigatório" })}
                    onChange={(e) => {
                      const masked = maskMoneyBR(e.target.value);
                      setValueEst("valorest", masked, { shouldDirty: true, shouldValidate: true });
                      triggerEst("valorest").then((isValid) => updateFieldValidationEst("valor", isValid));
                    }}
                  />
                </div>
                <div className={styles.inputbox}>
                  <span>Forma de pagamento</span>
                  <input type="text" value="Depósito" disabled/>
                </div>

                 <div className={`${styles.inputbox} ${fieldValidationsEst.banco ? '' : styles.invalid}`}>
                  <span>Banco</span>
                  <select name="banco"
                    {...registerEst("banco", { required: "O banco é obrigatório" })}
                    onChange={() => {
                      triggerEst("banco").then((isValid) => updateFieldValidationEst('banco', isValid));
                    }}
                  >
                    <option value="">Selecione um banco</option>
                    {moedaEstrangeiraInfo?.opcaobancos &&
                      Object.values(moedaEstrangeiraInfo.opcaobancos)
                        .filter(banco => banco.moesigla === moedaEstrangeiraInfo.moedaestrangeirasigla)
                        .map(banco => (
                          <option key={banco.pebid} value={banco.pebid}>{banco.pebnome}</option>
                        ))
                    }
                  </select>
                </div>

                <div className={styles.formButtons}>
                  <button type="submit">Enviar</button>
                  <button type="button" onClick={() => setShowModalEstrangeiro(false)}>Fechar</button>
                </div>
              </form>
            )}
          </ReactModal>

          {bills?.length > 0 ? 

          <>
            {bills.map(bill => { 
            return  <>
            {bill !== undefined && 
              <div
                id={`sale-${bill.id}`}
                className={`${styles.saleWrapper} ${String(bill.id) === String(highlightedSaleId) ? styles.highlight : ''}`}
                key={bill.key}
              >
                    <>
                    <div onClick={() => handleDropDown(bill.id)} className={styles.saleWrapperHeader}>
                      <h3>{bill.id}</h3>
                      { billsOpen.includes(bill.id) ? <BiSolidUpArrow/> : <BiSolidDownArrow/> }  
                    </div>
                    </>

                    { billsOpen.includes(bill.id) && 
                      <div className={styles.listWrapper}>
                        {

                          Object.keys(bill).map(b => {
                            // console.log(b)
                            let loop = bill; 
                            return (
                              <>

                              { (b == 0 && loop[b].vendatemsaldoestrangeiro) &&
                                <div onClick={() => openModal(loop[b], bill.id)} className={styles.billBoxSaldoEstrangeiro}>
                                  <section>
                                    <h3>Saldo em Moeda Estrangeira em Aberto</h3>
                                    <article>
                                      <span><b>Total:</b> {loop[b].moedaestrangeirasigla} {loop[b].moedaestrangeiratotal}</span>
                                      <span><b>Saldo quitação:</b> {loop[b].moedaestrangeirasigla} {loop[b].moedaestrangeirasaldoquitacao}</span>
                                    </article>               
                                  </section>
                                  <div className={styles.valortotal}>
                                    <h3>Pagar</h3>+
                                  </div>
                                  <div className={styles.descMobile}>
                                    <h3>Saldo em Moeda Estrangeira em Aberto</h3>
                                  </div>
                                </div>       


                              }

                              { !['boletos', 'cartao', 'id'].includes(b) && 
                                <div className={styles.billBox}>
                                  <section>
                                    <h3>{loop[b].descricao} {(loop[b].pagamentoestrangeiro && loop[b].moeda !== 'R$') ? 'EM MOEDA ESTRANGEIRA' : ''}</h3>
                                    <article>
                                      <span><b>Parcela:</b> {loop[b].parcela}/{loop[b].totalparcelas}</span>
                                      <span><b>Vencimento:</b> {loop[b].datavencimento}</span>
                                      {loop[b].datacompensacao !== null && <span><b>Pago:</b> {loop[b].datacompensacao}</span> }
                                    </article>

                                    {loop[b].datacompensacao !== null ?
                                      <button style={{backgroundColor: '#00c1d5'}} onClick={() => window.open(loop[b].recibo, '_blank')}>Ver recibo <HiOutlineDocumentText/></button> :

                                      <>
                                      {loop[b].boleto !== '' && 
                                        <>
                                        {loop[b].status === 2 ?
                                        <button
                                        style={{backgroundColor: '#FC4040'}}
                                        onClick={() => window.open(loop[b].boleto, '_blank')}>Ver boleto <HiOutlineDocumentText/></button>
                                        : 
                                        <button
                                        style={{backgroundColor: '#808080'}}
                                        onClick={() => window.open(loop[b].boleto, '_blank')}>Ver boleto <HiOutlineDocumentText/></button>
                                        }
                                        </>
                                      }                                  
                                      
                                      {(loop[b].boleto == '' && loop[b].descricao !== 'DEPOSITO / TRANSFERENCIA') &&
                                        <>
                                        {loop[b].linkpagamento !== '' ?
                                        <button
                                        style={{backgroundColor: '#FC4040'}}
                                        onClick={() => window.open(loop[b].linkpagamento, '_blank')}>Pagar <HiOutlineDocumentText/></button>
                                        : 
                                       'Aguardando Pagamento '
                                        }
                                        </>
                                      }                                  
                                      {(loop[b].descricao == 'DEPOSITO / TRANSFERENCIA') &&
                                        <>
                                        {loop[b].linkpagamento !== '' ?
                                        <button
                                        style={{backgroundColor: '#FC4040'}}
                                        onClick={() => window.open(loop[b].linkpagamento, '_blank')}>Pagar <HiOutlineDocumentText/></button>
                                        : 
                                        <>
                                          {loop[b].linkcomprovante == null ? 'Aguardando Depósito' : 'Comprovante anexado'}
                                          <span style={{ textAlign: 'start'}} dangerouslySetInnerHTML={{ __html: loop[b].info_deposito }} />
                                          {loop[b].linkcomprovante == null ? (
                                            <>
                                              <button type="button" onClick={() => handleUploadComprovante(`${bill.id}_${b}`)}>
                                                {loadingUpload ? 'Enviando...' : 'Anexar Comprovante'}
                                              </button>
                                              <input
                                                type="file"
                                                style={{ display: 'none' }}
                                                data-id={loop[b].id}
                                                data-idlancamento={loop[b].idlancamento}
                                                data-idvenda={loop[b].idvenda}
                                                data-idformapagamento={loop[b].idformapagamento}
                                                ref={(el) => (uploadComprovanteRef.current[`${bill.id}_${b}`] = el)}
                                                onChange={handleChangeUploadComprovante}
                                              />
                                            </>
                                          ) : (
                                            <button type="button" style={{ backgroundColor: '#00c1d5' }} onClick={() => window.open(loop[b].linkcomprovante, '_blank')}>
                                              Ver Comprovante
                                            </button>
                                          )}
                                        </>
                                        }
                                        </>
                                      }                                  
                                      </>
                                      
                                    }

                                  </section>
                                  <div className={styles.valortotal}>
                                    <h3>{loop[b].valortotal}</h3>
                                  </div>
                                  <div className={styles.descMobile}>
                                    <h3>{loop[b].descricao}</h3>
                                  </div>
                                </div>                    
                                }            
                              </>
                              )
                              
                          })
                        }
                      
                          {/* {bill['cartao'] !== undefined && 
                              <>
                                <div className={styles.billBox}>
                                <section>
                                  <h3>{bill['cartao'][0].descricao}</h3>
                                  <article>
                                    <span><b>Parcelas:</b> {bill['cartao'][0].totalparcelas}</span>
                                    <span><b>Data:</b> {bill['cartao'][0].datalancamento}</span>
                                  </article>

                                  {bill['cartao'][0].datacompensacao !== null ?
                                    <button style={{backgroundColor: '#00c1d5'}} onClick={() => window.open(bill['cartao'][0].recibo, '_blank')}>Ver recibo <HiOutlineDocumentText/></button> :
                                    ''
                                  }

                                  {bill['cartao'][0].datacompensacao == null ?
                                                                         
                                        <>
                                        {bill['cartao'][0].status === 3 ?
                                        <button
                                        style={{backgroundColor: '#FC4040'}}
                                        onClick={() => window.open(bill['cartao'][0].linkpagamento, '_blank')}>Pagar <HiOutlineDocumentText/></button>
                                        : 
                                        ''
                                        }
                                        </>
                                       : ''
                                    }
                                  

                                  </section>
                                  <div className={styles.valortotal}>
                                    <h3>{bill['cartao'][0].valortotalcartao}</h3>
                                  </div>
                                  <div className={styles.descMobile}>
                                    <h3>{bill['cartao'][0].descricao}</h3>
                                  </div>
                                </div>
                              </>
                            
                          } */}

                            {bill?.cartao !== undefined &&
                              <>
                                {Object.values(bill.cartao).map((item, i) => (
                                  <div className={styles.billBox} key={item?.id ?? item?.idlancamento ?? i}>
                                    <section>
                                      <h3>{item.descricao}</h3>
                                      <article>
                                        <span><b>Parcelas:</b> {item.totalparcelas}</span>
                                        <span><b>Data:</b> {item.datalancamento}</span>
                                      </article>

                                      {item.datacompensacao !== null ?
                                        <button
                                          style={{backgroundColor: '#00c1d5'}}
                                          onClick={() => window.open(item.recibo, '_blank')}
                                        >
                                          Ver recibo <HiOutlineDocumentText/>
                                        </button>
                                        : ''
                                      }

                                      {item.datacompensacao == null ?
                                        <>
                                          {item.status === 3 ?
                                            <button
                                              style={{backgroundColor: '#FC4040'}}
                                              onClick={() => window.open(item.linkpagamento, '_blank')}
                                            >
                                              Pagar <HiOutlineDocumentText/>
                                            </button>
                                            : ''
                                          }
                                        </>
                                        : ''
                                      }
                                    </section>

                                    <div className={styles.valortotal}>
                                      <h3>{item.valortotalcartao}</h3>
                                    </div>

                                    <div className={styles.descMobile}>
                                      <h3>{item.descricao}</h3>
                                    </div>
                                  </div>
                                ))}
                              </>
                            }


                        
                        { bill['boletos'] && 
                        <div className={styles.dropDownBoletos} >
                          <div className={styles.dropDownBoletosHeader} onClick={() => handleBoletos(bill.id)}>
                            <h3>Boletos</h3>
                            { boletosOpen.includes(bill.id)  ? <BiSolidUpArrow/> : <BiSolidDownArrow/> }                         
                            
                          </div>
                          {boletosOpen.includes(bill.id)  && 
                          <>
                          {
                          Object.keys(bill['boletos']).map(b => {
                            let loop = bill['boletos']; 
                            return (
                              <>
                                <div className={styles.billBox}>
                                <section>
                                  <h3>{loop[b].descricao}</h3>
                                  <article>
                                    <span><b>Parcela:</b> {loop[b].parcela}/{loop[b].totalparcelas}</span>
                                    <span><b>Vencimento:</b> {loop[b].datavencimento}</span>
                                    {loop[b].datacompensacao !== null && <span><b>Pago:</b> {loop[b].datacompensacao}</span> }
                                  </article>

                                  {loop[b].datacompensacao !== null ?
                                    <button style={{backgroundColor: '#00c1d5'}} onClick={() => window.open(loop[b].recibo, '_blank')}>Ver recibo <HiOutlineDocumentText/></button> :

                                    <>
                                      {loop[b].status === 2 ?
                                      <button
                                      style={{backgroundColor: '#FC4040'}}
                                      onClick={() => window.open(loop[b].boleto, '_blank')}>Ver boleto <HiOutlineDocumentText/></button>
                                      : 
                                      <button
                                      style={{backgroundColor: '#808080'}}
                                      onClick={() => window.open(loop[b].boleto, '_blank')}>Ver boleto <HiOutlineDocumentText/></button>
                                      }
                                    </>
                                  }

                                  </section>
                                  <div className={styles.valortotal}>
                                    <h3>{loop[b].valortotal}</h3>
                                  </div>
                                  <div className={styles.descMobile}>
                                    <h3>{loop[b].descricao}</h3>
                                  </div>
                                </div>
                              </>
                            )
                          })}
                          </>
                          }
                        </div>
                        }
                      </div>     
                    }              
             </div> 
             }    
             </>
            })}
          </>
         :
              <>
                <div className={styles.listWrapper}>
                  <h3>Nenhum boleto encontrado para a venda selecionada.</h3>
                </div>
              </>
            }
        </>
      }
    </div>
  );
}

export default BillsList;
